import Section from '@/Framework/UI/Pages/Landing/Sections/Section';
import SectionContainer from '@/Framework/UI/Pages/Landing/Sections/SectionContainer';
import SectionHeader from '@/Framework/UI/Pages/Landing/Sections/SectionHeader';
import Tabs from '@/Framework/UI/Pages/Landing/Sections/Tabs';
import { customersTabsList } from './tabs';

import styles from './customersLogos.scss';

const CustomersLogos = () => (
  <Section padding="top" className={ styles.sectionWrapper }>
    <SectionContainer>
      <SectionHeader
        title="A trusted platform for industry leading transactions."
        description="FINSIGHT’s specialized solutions have helped hundreds of leaders in your industry reach the right people at key stages of their deals."
        maxWidth={ 875 }
      />
    </SectionContainer>
    <SectionContainer size="large" narrow>
      <Tabs
        tabsList={ customersTabsList }
        dataTest="customersLogosTabs"
      />
    </SectionContainer>
  </Section>
);

export default CustomersLogos;
